import { render, staticRenderFns } from "./PastFairNavigation.vue?vue&type=template&id=85a6c97a&scoped=true"
import script from "./PastFairNavigation.vue?vue&type=script&lang=js"
export * from "./PastFairNavigation.vue?vue&type=script&lang=js"
import style0 from "./PastFairNavigation.vue?vue&type=style&index=0&id=85a6c97a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a6c97a",
  null
  
)

export default component.exports